module.exports = __webpack_public_path__ + "static/media/puzzleClue6.d8663c8a.png";